import { padStart } from "lodash";
// Both of these functions are meant to serve as an intermediate layer between the front end
// form and the backend api.
// The FrontEnd receives date values from the backend and stores them as Date Objects.
// We use formFormatDate in order to turn those values into string text we can populate
// the input with.
//
// formParseDate takes the string input and turns it into a Date object before it's
// sent to backend as a value.  It returns an empty string because any undefined values
// are stripped along with their keys, so you the empty string is a sign that
// the value got delete instead.
export const formFormatDate = (date: Date | null | undefined) =>
  date && [padStart(`${date.getUTCMonth() + 1}`, 2, "0"), padStart(`${date.getUTCDate()}`, 2, "0"), padStart(`${date.getUTCFullYear()}`, 2, "0")].join("/");
export const formParseDate = (value: string | null | undefined) => value && new Date(value);
export const formatZipCodes = (zipCodes) => (Array.isArray(zipCodes) ? zipCodes.join(", ") : "");
export const parseZipCodes = (value) => (typeof value === "string" ? value.split(/\s*,\s*/) : []);
export const formParseCurrency = (value) => (!value ? null : parseFloat(value.replace(/[^0-9.]/g, "")));
